module.exports = __webpack_public_path__ + "img/dashboard.500c3db2.svg";